export const partners = [
  "Generali",
  "Swiss Life",
  "Primonial",
  "Corum",
  "Cardif",
  "Spirica",
  "Suravenir",
  "Oradéa Vie",
  "Perial",
  "Altarea",
];
